import { render } from "./ModalAdminConfirm.vue?vue&type=template&id=415a49b6&scoped=true"
import script from "./ModalAdminConfirm.vue?vue&type=script&lang=js"
export * from "./ModalAdminConfirm.vue?vue&type=script&lang=js"

import "./ModalAdminConfirm.vue?vue&type=style&index=0&id=415a49b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-415a49b6"]])

export default __exports__